module.exports = __webpack_public_path__ + "img/overview.7233ae4b.svg";